var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { attrs: { "no-border": "", highlight: "", separator: "" } },
    [
      _vm._l(_vm.members, function(member, index) {
        return _c("team-member-list-entry", {
          key: "member" + index,
          attrs: { member: member }
        })
      }),
      _vm._l(_vm.invites, function(invite, index) {
        return _vm.showInvites
          ? _c("team-invite-list-entry", {
              key: "invite" + index,
              attrs: { invite: invite }
            })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }